import CreateReceiptForm from 'components/features/create-receipt-form';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function CreateReceipt() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('cashReceipts.receipting')}>
      <CreateReceiptForm />
    </HomeLayout>
  );
}

export default CreateReceipt;
